import React from "react";

function TemplatePointers() {
  return (
    <>
      <h1 className="text-2xl mt-8 font-bold">Welcome to GPTZero</h1>
      <p className="py-2 mt-4">
        <span className="font-semibold">Log in with your GPTZero account to continue.</span>
      </p>
    </>
  );
}

export default TemplatePointers;
